import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.number.isRequired,
  slug: PropTypes.string,
  title: PropTypes.string.isRequired
};

export const defaultProps = {
  slug: null
};

export const mapPropTypes = {
  [PropTypes.number]: PropTypes.shape(propTypes)
};

export default { defaultProps, propTypes, mapPropTypes };
